module.exports = __webpack_public_path__ + "static/media/Gruppenbild_Schule-dunkelblau.d84610b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_bei_den_Umzuegen/thumb/Gruppenbild_Schule-dunkelblau.jpg
// module id = 441
// module chunks = 0